import DeleteIcon from '@/assets/icon-delete.svg?react';

const ColorItem = ({ hex, index, onEdit, onDelete }) => {
  return (
    <div className="color-item col-6">
      <div
        className="color-item__swatch"
        style={{ backgroundColor: hex?.hex }}
        onClick={() => onEdit(index, hex)}
      />
      <input
        type="text"
        value={hex?.hex}
        className="color-item__input"
        readOnly
        aria-label={`${hex?.hex}`}
      />
      <button
        className="color-item__delete"
        aria-label="Delete color"
        onClick={() => onDelete(hex)}
      >
        <DeleteIcon />
      </button>
    </div>
  );
};

export default ColorItem;
